var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-form",
        {
          ref: "formData",
          attrs: { model: _vm.formData, "label-width": "110px" },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lh13",
              attrs: { label: "项目名称：", prop: "name" },
            },
            [_c("span", [_vm._v(_vm._s(_vm.formData.name || "- -"))])]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "select-bar",
              attrs: { label: "负责人：", prop: "uid" },
            },
            [
              _c(
                "div",
                { staticClass: "mb-10" },
                _vm._l(_vm.formData.admins, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "avatar-box members-box" },
                    [
                      _c("img", { attrs: { src: item.avatar, alt: "" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.name || "- -"))]),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "select-bar", attrs: { label: "项目成员：" } },
            [
              _c(
                "div",
                { staticClass: "mb-10" },
                [
                  _vm._l(_vm.formData.members, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "avatar-box members-box" },
                      [
                        _c("img", { attrs: { src: item.avatar, alt: "" } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "members-box-content" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  !_vm.formData.members
                    ? _c("span", [_vm._v("- -")])
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "select-bar",
              attrs: { label: "计划开始：", prop: "start_date" },
            },
            [_c("span", [_vm._v(_vm._s(_vm.formData.start_date || "- -"))])]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "select-bar",
              attrs: { label: "计划结束：", prop: "end_date" },
            },
            [_c("span", [_vm._v(_vm._s(_vm.formData.end_date || "- -"))])]
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "关联客户：", prop: "eid" } }, [
            _c("div", [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.formData.customer
                      ? _vm.formData.customer.customer_name
                      : "- -"
                  )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.formData.eid
            ? _c(
                "el-form-item",
                { attrs: { label: "关联合同：", prop: "cid" } },
                [
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formData.contract
                            ? _vm.formData.contract.contract_name
                            : "--"
                        )
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "项目状态：", prop: "status" } },
            [
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.formData.status == 0
                        ? "正常"
                        : _vm.formData.status == 1
                        ? "暂停"
                        : "关闭"
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "项目描述：" } }, [
            _c("span", [_vm._v(_vm._s(_vm.formData.describe || "- -"))]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }